import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import getChatBySessionId from '../selectors/getChatBySessionId';
import { removePresenceSubscription } from '../presenceManager/presenceSubscription';
import {
    removeParticipant as removeParticipantAction,
    addChatMessage,
} from '../actions/ucmaActions';
import { ChatMessageType } from '../store/schema/ChatMessageViewState';

export default function removeParticipant(notification: InstantMessagePayload) {
    const { ChatSessionId, SipUri } = notification;
    const chat = getChatBySessionId(ChatSessionId);
    if (chat) {
        if (chat.participants.length == 1) {
            // Comments below are copied from jsMVVM:
            // Strange as it may seem, Lync does not indicate to the user
            // when the last participant has left.  The idea seems to be
            // to keep the window open so that you can continue to bother
            // them even after they have tried to ignore you.
            // See O15:2798681 for side-effects of changing this behavior.
            return;
        }
        if (chat.participants.indexOf(SipUri) >= 0) {
            removePresenceSubscription([SipUri]);
            removeParticipantAction(chat, SipUri);
            addChatMessage(chat, ChatMessageType.ParticipantLeave, SipUri);
        }
    }
}
